import { TopBar } from '../TopBar';
import { NavBar } from '../NavBar';
import React, { useEffect, useState } from 'react';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { HeaderTypes } from './headerTypes';

export const Header = ({
  topbardata,
  navbardata,
  onSetHeaderHeight,
  locationDetails,
  globalContext,
  logOutHandler,
}: HeaderTypes.THeaderComponentType) => {
  const [topBarHeight, setTopBarHeight] = useState(0);
  const [navBarHeight, setNavBarHeight] = useState(0);
  const { width } = useWindowDimensions();

  useEffect(() => {
    function calcHeight() {
      if (onSetHeaderHeight) {
        onSetHeaderHeight({
          height: topBarHeight + navBarHeight,
          screenWidth: width,
        });
      }
    }
    calcHeight();
  }, [topBarHeight, navBarHeight]);

  return (
    <div className="Header">
      {Object.keys(topbardata).length > 0 && (
        <TopBar
          hideOnMobileDevice={topbardata.hideOnMobileDevice}
          closeButton={topbardata.closeButton}
          showAnnouncementBar={topbardata.showAnnouncementBar}
          locationType={topbardata.locationType}
          ctaText={topbardata.ctaText}
          locations={topbardata.locations}
          iconsConfig={topbardata.iconsConfig}
          syrasoftEmailID={topbardata.syrasoftEmailID}
          variant={topbardata.variant}
          buttonsConfig={topbardata.buttonsConfig}
          announcementInfo={topbardata.announcementInfo}
          onSetTopBarHeight={setTopBarHeight}
          theme={topbardata.theme}
        />
      )}
      <NavBar
        theme="dark"
        locations={navbardata.locations}
        iconsConfig={navbardata.iconsConfig}
        locationType={navbardata.locationType}
        navLinks={navbardata.navLinks}
        LinkWrapper={navbardata.LinkWrapper}
        buttonsConfig={navbardata.buttonsConfig}
        onSetNavBarHeight={setNavBarHeight}
        locationDetails={locationDetails}
        globalContext={globalContext}
        logOutHandler={logOutHandler}
      />
    </div>
  );
};

export default Header;
